import axios from 'axios';


// For production, use your subdomain or VPS IP
export const ONLYOFFICE_SERVER_URL = 'https://office.interior.pinkmoontech.com'; 
// export const ONLYOFFICE_SERVER_URL = 'http://YOUR_VPS_IP:9000';

//export const API_BASE_URL = 'http://localhost:5050';

export const API_BASE_URL = 'https://qa.backend.admin.vervekitchens.com';
//export const API_BASE_URL = 'https://backend.admin.vervekitchens.com';

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('blum_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('blum_token');
      localStorage.removeItem('blum_user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;